import { NgIf } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { StateService } from '../../../services/state.service'
import { PlatformService } from '../../../platforms/platform.service'

@Component({
  selector: 'app-customer-register-widget',
  standalone: true,
  imports: [NgIf, ReactiveFormsModule],
  templateUrl: './customer-register.component.html',
  styleUrls: ['./customer-register.component.scss'],
})
export class CustomerRegisterComponent implements OnInit {
  registerForm!: FormGroup
  message?: string

  constructor(
    private formBuilder: FormBuilder,
    private stateService: StateService,
    private platformService: PlatformService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      code: '',
      roomNumber: '',
    })
    this.platformService.initVirtualKeyboard()
  }

  onSubmit(): void {
    this.message = undefined
    const code = this.registerForm.value.code.toUpperCase()
    const roomNumber = this.registerForm.value.roomNumber
    this.stateService
      .checkRegistration(code, roomNumber)
      .then(isRegistered => {
        if (isRegistered) {
          this.message = undefined
        } else {
          this.message = 'Invalid code'
        }
      })
      .catch(err => {
        this.message = err.message
      })
  }
}
